import React from "react";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Button } from "components/haven-design";
import { useSnackbar } from "components/haven-design/snackbar";
import { Delta } from "components/message-editor/types";
import CopyConfirmationModal from "./copy-confirm-modal";

type CopyConfirmationButtonProps = {
  hidden?: boolean;
  onCopy: () => void;
  context: "Letter" | "Email";
  valueToReplace: Delta;
}

const CopyConfirmationButton:React.FC<CopyConfirmationButtonProps> = ({
  hidden = false, onCopy, context, valueToReplace,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { openSnackbar } = useSnackbar();

  const copyAndToast = () => {
    onCopy();
    openSnackbar({ message: `Successfully copied to ${context}`, status: "success" });
  };

  const handleButtonOnClick = () => (valueToReplace.ops.length ? setIsOpen(true) : copyAndToast());

  return (
    <div style={{ display: "flex", alignItems: "center", paddingBottom: "10px" }}>
      <Button
        hidden={hidden}
        color="secondary"
        onClick={handleButtonOnClick}
      >
        <FileCopyIcon />&nbsp;Copy to {context}
      </Button>
      <CopyConfirmationModal
        context={context}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirmation={() => {
          copyAndToast();
          setIsOpen(false);
        }}
      />
    </div>
  );
};

export default CopyConfirmationButton;
